import actions from './actions'

const initialState = {
  data: [],
  isFetching: false,
  error: '',
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_COMPANIES: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }

    case actions.FETCH_COMPANIES_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
        error: '',
      }
    }

    case actions.FETCH_COMPANIES_ERROR: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case actions.COMPANY_SET: {
      return {
        ...state,
        data: action.data,
        isSaving: true,
        error: '',
      }
    }

    case actions.COMPANY_ADD: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.COMPANY_DEL: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.COMPANY_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        error: '',
      }
    }

    case actions.COMPANY_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    default: {
      return state
    }
  }
}
